import flattenMessages from '../../../helpers/flattenMessages';

export default {
  en: flattenMessages({}, 'faq'),
  ja: flattenMessages({}, 'faq'),
};
